export interface Industry {
    _id: string;
    name: string;
    subIndustries: { name: string; sub?: string[] }[];
}

export interface WhatsappList {
    _id: string;
    name: string;
    description: string;
    industries: { _id: string; name: string }[];
    subIndustries: string[];
    userIds: string[];
    createdAt: string;
}

export interface UserWithPhone {
    _id: string;
    name: string;
    surname: string;
    email: string;
    phone: string;
    type: string;
}

export interface WhatsappTemplate {
    sid: string;
    friendlyName: string;
    language: string;
    contentType: string | null;
    body: string;
    variables: Record<string, string>;
    approval: {
        status: string;
        category: string;
        name: string;
        rejectionReason: string;
    } | null;
    dateCreated: string;
    dateUpdated: string;
    isDefault?: boolean;
}

export interface TemplatesFallback {
    fallback: boolean;
    fallbackReason?: string;
}

export const APPROVAL_STATUS: Record<string, { label: string; className: string }> = {
    approved: { label: 'Approuvé', className: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300' },
    pending: { label: 'En attente', className: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300' },
    received: { label: 'Reçu', className: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300' },
    rejected: { label: 'Rejeté', className: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300' },
    paused: { label: 'En pause', className: 'bg-gray-200 text-gray-700 dark:bg-navy-600 dark:text-gray-300' },
    disabled: { label: 'Désactivé', className: 'bg-gray-200 text-gray-700 dark:bg-navy-600 dark:text-gray-300' },
    unsubmitted: { label: 'Non soumis', className: 'bg-gray-100 text-gray-500 dark:bg-navy-700 dark:text-gray-400' },
};

export const getApprovalStatus = (tpl: WhatsappTemplate) =>
    APPROVAL_STATUS[tpl.approval?.status || 'unsubmitted'] ?? {
        label: tpl.approval?.status || '',
        className: 'bg-gray-100 text-gray-500',
    };

// Extract {{1}}, {{2}}… placeholders from a template body
export const extractPlaceholders = (body: string): string[] => {
    const keys = new Set<string>();
    for (const m of body.matchAll(/\{\{\s*(\w+)\s*\}\}/g)) keys.add(m[1]);
    return [...keys].sort((a, b) => Number(a) - Number(b));
};

export const getAvailableSubIndustries = (industries: Industry[], selectedIndustryIds: string[]) => {
    const subs: string[] = [];
    industries
        .filter((ind) => selectedIndustryIds.includes(ind._id))
        .forEach((ind) => ind.subIndustries.forEach((s) => {
            if (!subs.includes(s.name)) subs.push(s.name);
            (s.sub || []).forEach((ss) => { if (!subs.includes(ss)) subs.push(ss); });
        }));
    return subs;
};
